import { FC } from 'react';
import styles from './SamplePlanTable.module.scss';
import {
  UnassignedGroup,
  SectionType,
  useSamplePlanTableContext,
  useOpenSection,
} from '@/components/Samples/SamplePlanTable/SamplePlanTableProvider';
import { SampleDefinitionFormData, GroupTarget } from '@/model/SamplePlan.model';
import cn from 'classnames';
import { RiArrowRightWideFill } from 'react-icons/ri';

export const ChevronCell: FC<{
  type: SectionType;
  id: SampleDefinitionFormData['api_id'] | GroupTarget['api_id'] | UnassignedGroup;
  className?: string;
  disabled?: boolean;
}> = ({ type, id, disabled = false, className }) => {
  const { toggle } = useSamplePlanTableContext();
  const open = useOpenSection(type, id);
  if (disabled) {
    return (
      <div
        className={cn(styles.ChevronCell, styles.Disabled)}
        data-test-component="ChevronCell"
        data-test-element={`${type}-disabled`}
      ></div>
    );
  }
  return (
    <div
      className={cn(styles.ChevronCell, { [styles.Open]: open, [styles.Closed]: !open })}
      onClick={() => toggle(type, id)}
      data-test-component="ChevronCell"
      data-test-element="container"
    >
      <RiArrowRightWideFill className={className} />
    </div>
  );
};
